import React from 'react'

import Amount       from './Amount'
import CarbonOffset from './CarbonOffset'
import Intro        from '../Intro'
import Tribute      from '../Tribute'
import DataSharing  from '../DataSharing'
import Contact      from '../fiat/Contact'
import InvalidForm  from 'src/components/InvalidForm'

const Form = ({
  i18n, show_input_labels, inputProps, partnerItem, beneficiarySelect,
  shares, setShares, defaultShares, loading, foundation, collect_phone,
  partner, partner_is_pledge, data_sharing, handleSubmit,
  errors, displayAmount, convertedAmount, handleAmountChange, toggleMode,
  donation, currencies, setFiatCurrency, setCryptoCurrency,
  accounts, top_accounts, topPanel, plugins, tribute, session,
  blank_modal_src, widget_instance_token,
}) =>
  <form className="position-relative" onSubmit={handleSubmit} noValidate>
    <Intro i18n={i18n} />

    <InvalidForm>{errors?.base?.[0]}</InvalidForm>

    {plugins.renderError()}
    {plugins.renderHook('afterIntro', 'crypto', { donation })}

    <Tribute tribute={tribute} />

    <h2 className="h5 section-heading section-heading-donation">
      {i18n.t('donation')}
    </h2>

    {beneficiarySelect.render()}

    <Amount
      i18n={i18n}
      errors={errors}
      displayAmount={displayAmount}
      convertedAmount={convertedAmount}
      handleAmountChange={handleAmountChange}
      toggleMode={toggleMode}
      state={donation.state}
      currencies={currencies}
      setFiatCurrency={setFiatCurrency}
      setCryptoCurrency={setCryptoCurrency}
      accounts={accounts}
      top_accounts={top_accounts}
      blank_modal_src={blank_modal_src}
      widget_instance_token={widget_instance_token}
    />

    {plugins.renderHook('afterAmounts', 'crypto', { donation })}
    {plugins.renderHook('afterSubscription', 'crypto', { donation })}

    <Contact
      i18n={i18n}
      session={session}
      collect_phone={collect_phone}
      donation={donation}
      inputProps={inputProps}
      show_input_labels={show_input_labels}
      errors={errors}
      hideAddress={[ 'fiat', 'deferred' ].includes(topPanel)}
    />

    <div className="mb-3">
      <DataSharing
        i18n={i18n}
        foundation={foundation}
        partner={partner}
        partner_is_pledge={partner_is_pledge}
        data_sharing={data_sharing}
        beneficiary={partnerItem.beneficiary}
        shares={shares}
        setShares={setShares}
        defaultShares={defaultShares}
      />
    </div>
    {plugins.renderHook('afterDataSharing', 'crypto', { donation })}

    <div className="mb-3 d-grid">
      <button className="btn btn-primary" disabled={loading}>
        {loading ? i18n.t('loading') : i18n.t('continue')}
      </button>
    </div>

    <CarbonOffset />
  </form>

export default Form
